import React from 'react';
import {IoLogoAndroid} from 'react-icons/io';
import {FaApple} from 'react-icons/fa';
import {FaDesktop} from 'react-icons/fa6';
import {Platform} from './enums/devices';

// Set the API server URL based on the environment
export const REACT_APP_API_SERVER = (() => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isCapacitor = !!(window as any).Capacitor?.isNativePlatform?.();
  const isDevelopment = process.env.NODE_ENV === 'development';
  const isStaging = window.location.hostname === 'dev.tonzocash.com';
  
  // Production build served from production domain
  if (window.location.hostname === 'tonzocash.com' || window.location.hostname === 'www.tonzocash.com') {
    return 'https://api.tonzocash.com/v1';
  }
  
  // Staging environment (dev.tonzocash.com)
  if (isStaging) {
    return 'https://api.tonzocash.com/v1';
  }
  
  // Capacitor development (Android emulator during development)
  if (isCapacitor && isDevelopment) {
    return 'http://10.0.2.2:5000/v1'; // Android emulator
  }
  
  
  // Capacitor production (actual app builds)
  if (isCapacitor) {
    // return 'http://10.0.2.2:5000/v1'; // todo: in testing uncomment this to allow Android emulator connect to local API and comment below
    return 'https://api.tonzocash.com/v1'; // Production API for mobile app
  }
  
  // Browser development
  if (isDevelopment && isLocalhost) {
    return 'http://127.0.0.1:5000/v1'; // Browser development
  }
  
  // Fallback to production
  return 'https://api.tonzocash.com/v1';
})();



export const APP_PATHS = {
  BASE: '/',
  OFFERS: '/offers',
  OFFER: '/offer',
  SURVEYS: '/surveys',
  CASHOUT: '/cashout',
  PROFILE: '/profile',
  ERROR: '/error',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  EMAIL_CONFIRMATION: '/email-confirmation',
  RESET_PASSWORD: '/reset_password',
  VERIFY_EMAIL: '/verify_email',
  LOGIN: '/login',
  SIGN_UP: '/signup',
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us'
};

export const API_ROUTES = {
  AUTH: {
    LOGIN: '/login',
    USER: '/user',
    VERIFY_EMAIL: '/verify_email',
    SEND_VERIFY_EMAIL_LINK: '/send_verify_email_link',
    PUSH_TOKEN: '/push_token'
  },
  PASSWORD: {
    RESET: '/reset_password',
    SEND_LINK: '/send_reset_link'
  },
  OFFERS: {
    LIST: '/offers',
    OFFER: '/offer'
  },
  SEND_CONTACT_FORM: '/contact_us',
  QR_CODE: '/qr_gent',
  ACTIVITY_STATS: '/activity_stats',
  WITHDRAWALS: '/history/withdrawals',
  REWARDS: '/history/rewards',
  CASHOUT: {
    VENDORS_DATA: '/payout_vendors_data',
    CREATE_WITHDRAWAL: '/withdraw',
    GET_WITHDRAWAL_LINK: '/withdraw',
  },
  ANALYTICS: '/web_event',
  FIREBASE_INSTANCE_ID: '/firebase_instance_id',
  SURVEYS_LINK: '/surveys'
};

export const QUERY_KEYS = {
  OFFERS: {
    LIST: 'offers/list',
    OFFER: 'offers/offer'
  },
  USER: {
    DETAILS: 'users/details',
    EARNING_IN_PROGRESS: 'users/earning-in-progress',
    EARNING_COMPLETED: 'users/earning-completed',
    VERIFY_EMAIL: 'users/verify-email',
    ACTIVITY_STATS: 'users/activity-stats',
    WITHDRAWALS_HISTORY: 'users/withdrawals-history',
    REWARDS_HISTORY: 'users/rewards-history',
    SURVEYS_LINK: 'users/surveys'
  },
  CASHOUT: {
    VENDORS_DATA: 'cashout/vendors-data'
  }
};

// List of keys that are used in app to store data in local storage/ session storage
export const TOKEN_KEY = 'access_token';
export const FIRST_URL = 'first_url';
export const FIRST_REFERRER = 'first_referrer';
export const LAST_REFERRER = 'last_referrer';
export const DEVICE_ID = 'device_id';
export const SESSION_ID = 'session_id';
export const ACTIVE_VERSION = 'active_version';

export const devicesIcon: Record<Platform, React.FC> = {
  [Platform.ANDROID]: IoLogoAndroid,
  [Platform.IOS]: FaApple,
  [Platform.DESKTOP]: FaDesktop
};

export const BREAKPOINTS = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400
};

export const validationRules = {
  password: {
    pattern: {
      value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
      message: 'Password must contain at least 8 characters, including letters and numbers'
    }
  },
  email: {
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: 'The field must be the email address'
    }
  }
};

export const GOOGLE_CLIENT_ID = '10663262278-fr313efhhdtn9jjko9qta29mcskdldi4.apps.googleusercontent.com';

// Firebase configuration (extracted from google-services.json)
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAZhAhQXX-Hcc7q9jeXnZB-IiI6lMjeS2k",
  authDomain: "spry-blade-457600-p6.firebaseapp.com",
  projectId: "spry-blade-457600-p6",
  storageBucket: "spry-blade-457600-p6.firebasestorage.app",
  messagingSenderId: "10663262278",
  appId: "1:10663262278:android:656ff0433a629f9d69b247"
};
